var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Cookies from 'js-cookie';
import Vue from 'vue';
import { Ref, Component } from 'vue-property-decorator';
import RootApp from '@/common/components/layouts/RootApp.vue';
import { Action, Getter, namespace, State } from 'vuex-class';
import { container } from 'tsyringe';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { User } from 'packages/users/User';
import { LanguageService } from 'services/LanguageService';
var companyModule = namespace('companyModule');
var companySettings = namespace('companySettings');
var profile = namespace('profile');
var beta = namespace('beta');
var AppWrapper = /** @class */ (function (_super) {
    __extends(AppWrapper, _super);
    function AppWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.authenticator = container.resolve(Authenticator);
        _this.languageService = container.resolve(LanguageService);
        return _this;
    }
    Object.defineProperty(AppWrapper.prototype, "hasSeenOOO", {
        get: function () {
            var _a;
            return (_a = Cookies.get('jobilla_seen_ooo')) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    AppWrapper.prototype.verifyOOOMode = function () {
        Cookies.set('jobilla_seen_ooo', 'true', { expires: 5 });
        this.inspector.close();
    };
    AppWrapper.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentUserWithUnit()];
                    case 1:
                        _a.sent();
                        this.languageService.setLanguage(this.user.language);
                        container.registerInstance('appCanvas', this.holidayCanvas);
                        this.$posthog.onFeatureFlags(function () {
                            var isOOOModeEnabledForJobilla = _this.$posthog.isFeatureEnabled('is-ooo-mode-enabled-for-jobilla');
                            if (isOOOModeEnabledForJobilla && !_this.hasSeenOOO) {
                                _this.inspector.open();
                            }
                        });
                        return [4 /*yield*/, Promise.all(__spreadArray([
                                this.getUserBetas(),
                                this.loadCompany()
                                    .catch(function (e) {
                                    var _a;
                                    if (((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                                        _this.$router.push({ name: 'Error.404' });
                                    }
                                    throw e;
                                })
                            ], (this.currentCompanyId ? [
                                this.retrieveBrandingSettings(this.currentCompanyId),
                                this.loadFeatures(this.currentCompanyId),
                                this.loadAttributes(this.currentCompanyId),
                            ] : [])))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var _a, _b;
    __decorate([
        Getter,
        __metadata("design:type", Number)
    ], AppWrapper.prototype, "currentCompanyId", void 0);
    __decorate([
        State('activeModule'),
        __metadata("design:type", String)
    ], AppWrapper.prototype, "module", void 0);
    __decorate([
        profile.State,
        __metadata("design:type", Boolean)
    ], AppWrapper.prototype, "loading", void 0);
    __decorate([
        profile.State,
        __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
    ], AppWrapper.prototype, "user", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], AppWrapper.prototype, "loadFeatures", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], AppWrapper.prototype, "loadAttributes", void 0);
    __decorate([
        beta.Action,
        __metadata("design:type", Function)
    ], AppWrapper.prototype, "getUserBetas", void 0);
    __decorate([
        profile.Action,
        __metadata("design:type", Function)
    ], AppWrapper.prototype, "getCurrentUserWithUnit", void 0);
    __decorate([
        companyModule.Action,
        __metadata("design:type", Function)
    ], AppWrapper.prototype, "loadCompany", void 0);
    __decorate([
        companySettings.Action,
        __metadata("design:type", Function)
    ], AppWrapper.prototype, "retrieveBrandingSettings", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", typeof (_b = typeof HTMLCanvasElement !== "undefined" && HTMLCanvasElement) === "function" ? _b : Object)
    ], AppWrapper.prototype, "holidayCanvas", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], AppWrapper.prototype, "inspector", void 0);
    AppWrapper = __decorate([
        Component({
            components: {
                RootApp: RootApp,
            },
            beforeRouteEnter: function (to, from, next) {
                var _a, _b;
                var authenticator = container.resolve(Authenticator);
                if ((_a = to.params) === null || _a === void 0 ? void 0 : _a.companyId) {
                    authenticator.selectCompany((_b = to.params) === null || _b === void 0 ? void 0 : _b.companyId);
                }
                return next();
            },
        })
    ], AppWrapper);
    return AppWrapper;
}(Vue));
export default AppWrapper;
